import { render } from "./CompanyCapacityRowComponent.vue?vue&type=template&id=63e59b08"
import script from "./CompanyCapacityRowComponent.vue?vue&type=script&lang=js"
export * from "./CompanyCapacityRowComponent.vue?vue&type=script&lang=js"

import "./CompanyCapacityRowComponent.vue?vue&type=style&index=0&id=63e59b08&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__